"use client";

import * as React from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "./cn";

export const Sheet = SheetPrimitive.Root;
export const SheetTrigger = SheetPrimitive.Trigger;
export const SheetClose = SheetPrimitive.Close;

export const SheetContent = React.forwardRef<
  React.ElementRef<typeof SheetPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof SheetPrimitive.Content> & {
    title?: string;
    description?: string;
    bodyClassName?: string;
  }
>(({ className, bodyClassName, children, title, description, ...props }, ref) => (
  <SheetPrimitive.Portal>
    <SheetPrimitive.Overlay className="fixed inset-0 z-50 bg-black/40 data-[state=open]:animate-fade-in" />
    <SheetPrimitive.Content
      ref={ref}
      className={cn(
        "fixed inset-y-0 right-0 z-50 flex w-full max-w-lg flex-col border-l border-border bg-card shadow-lg duration-panel ease-out data-[state=open]:animate-slide-in-right",
        className,
      )}
      {...props}
    >
      <div className="flex items-start justify-between border-b border-border px-6 py-4">
        <div className="space-y-1">
          {title ? (
            <SheetPrimitive.Title className="text-lg font-semibold">{title}</SheetPrimitive.Title>
          ) : (
            <SheetPrimitive.Title className="sr-only">Panel</SheetPrimitive.Title>
          )}
          {description ? (
            <SheetPrimitive.Description className="text-sm text-muted-foreground">
              {description}
            </SheetPrimitive.Description>
          ) : null}
        </div>
        <SheetPrimitive.Close
          className="rounded-md p-1 text-muted-foreground transition-colors duration-micro hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="Close"
        >
          <X className="size-4" />
        </SheetPrimitive.Close>
      </div>
      <div className={cn("min-h-0 flex-1 overflow-y-auto px-6 py-4", bodyClassName)}>{children}</div>
    </SheetPrimitive.Content>
  </SheetPrimitive.Portal>
));
SheetContent.displayName = "SheetContent";
